"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManager_1 = require("../ApiManager");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiSms = /** @class */ (function (_super) {
    __extends(ApiSms, _super);
    function ApiSms() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.PUT_SMS_AUTH_KEY = "/auth/smsAuthKeySend";
        _this.VALIDATION_AUTH_KEY = "/auth/smsAuthKeyValidation";
        _this.AUTH_KEY_STAT_LAYER_COUNT = "/auth/smsAuthKeyStatLayerCount";
        _this.AUTH_KEY_CONFIRM = "/auth/smsAuthKeyConfirm";
        /**
         * SMS 인증번호 전송 요청
         * @param token
         * @param phoneNumber
         * @returns
         */
        _this.sendAuthKey = function (token, phoneNumber) {
            var data = {
                phoneNumber: phoneNumber,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: "post",
                url: _this.PUT_SMS_AUTH_KEY,
                data: data,
            });
        };
        /**
         * SMS 인증번호 검증
         * @param token
         * @param phoneNumber
         * @param authKey
         * @returns
         */
        _this.validationSmsAuthKey = function (token, phoneNumber, authKey) {
            var data = {
                phoneNumber: phoneNumber,
                authKey: authKey,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: "post",
                url: _this.VALIDATION_AUTH_KEY,
                data: data,
            });
        };
        /**
         * SMS 인증 번호 확인 및 등록처리
         * @param token
         * @param phoneNumber
         * @param authKey
         * @returns
         */
        _this.confirmAuthKey = function (token, phoneNumber, authKey) {
            var data = {
                phoneNumber: phoneNumber,
                authKey: authKey,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: "post",
                url: _this.AUTH_KEY_CONFIRM,
                data: data,
            });
        };
        /**
         * SMS Layer - CountUp
         * @param token
         * @returns
         */
        _this.LayerCount = function (token) {
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: "post",
                url: _this.AUTH_KEY_STAT_LAYER_COUNT,
            });
        };
        return _this;
    }
    ApiSms.getInstance = function (initValue) {
        if (!ApiSms.classInstance) {
            this.classInstance = new ApiSms(initValue);
        }
        return this.classInstance;
    };
    return ApiSms;
}(ApiManager_1.ApiManager));
exports.default = ApiSms;
